export const getDefaultClientFormData = () => ({
	name: "",
	responsible_name: "",
	responsible_document: "",
	type_person: "legal",
	type: "",
	document: " ",
	trade_name: "",
	creci: "",
	phone: " ",
	mobilePhone: "",
	email: "",
	address_zipcode: " ",
	address_street: "",
	address_number: "",
	typecomplement: "",
	address_complement: "",
	address_district: "",
	address_city: "",
	address_state: "",
	status: "active",
	created_from: "web",
	invoice_due_date: "10",
	invoiceGateway: "SICOOB",
	cadastro: new Date(),
	pix_key: "",
	agency_number: "",
	agency_digit: "",
	account_number: "",
	account_digit: "",
	bank_manager: "",
	observationPartner: "",
	observation: "",
	creditCard: "inactive",
	bonusActive: "inactive",
	comissionActive: "inactive",
	tax_setup_enable: "0",
	tax_setup_limit_default: "0",
	tax_setup_limit_max: "0",
	tax_setup_limit_min: "0",
});
